import * as d3 from 'd3'
export const CATEGORY_DATA = [
  {
    name: '',
    id: 'general',
    order: 0,
    table: false
  },
  {
    name: 'Medikamenten-Übergebrauch-Kopfschmerz',
    id: 'moh',
    order: 3,
    table: true
  },
  {
    name: 'Migräne',
    id: 'migrain',
    order: 1,
    table: true
  },
  {
    name: 'Spannungs<strong>-</strong>kopfschmerz',
    id: 'tension',
    order: 2,
    table: true
  },
  {
    name: 'Cluster-Kopfschmerzen',
    id: 'cluster',
    order: 4,
    table: true
  }
].sort((a, b) => {
  return a.order - b.order
})
export interface CategoryData {
  name: string
  id: string
  order: number
  table: boolean
}
// console.log('CATEGORY DATA:', CATEGORY_DATA)
export const LOCALES: {
  DE?: { [KEY: string]: string }
  FR?: { [KEY: string]: string }
} = {
  DE: require('locales/de.yml')
}

interface FactEntry {
  headache: string
  type: string
  order: number
  hasImage: 'yes' | 'no'
  text: string
}
export type headacheTypes = 'migrain' | 'tension' | 'moh' | 'cluster'
type tableSegments = 'symptoms' | 'who' | 'causes' | 'treatment'
export type FactSegmentEntries = {
  hasImage: 'yes' | 'no'
  headache: headacheTypes
  order: string
  text: string
  type: tableSegments
}[]
export interface FactDataForCategoryInterface {
  key: tableSegments
  values: FactSegmentEntries
}

export interface FactDataInterface {
  key: headacheTypes
  values: FactDataForCategoryInterface[]
}

const rawFactData: FactEntry[] = require('./kopfschmerz-facts - 1.csv')

export const FACT_DATA: FactDataInterface[] = d3
  .nest()
  .key(function(d: FactEntry) {
    return d.headache
  })
  .key(function(d: FactEntry) {
    return d.type
  })
  .entries(rawFactData)

export const sourceList = [
  'Dr. med. Reto Agosti, Chefarzt des Kopfwehzentrums an der Hirslanden-Klinik in Zürich',
  'PD Dr. med. Andreas Gantenbein, Präsident der Schweizerischen Kopfwehgesellschaft, Chefarzt Neurologie RehaClinic Bad Zurzach',
  'Prof. Dr. med. Hartmut Göbel, Schmerzklinik Kiel',
  'Cochrane Database of Systematic Reviews',
  'American Migraine Foundation',
  'American Headache Society',
  'Therapie der Migräneattacke und Prophylaxe der Migräne, S1-Leitlinie, 2018',
  'pharma-kritik',
  'Alpay K et al, Cephalalgia 2010',
  'Ashina M et al, Lancet Neurology 2019',
  'Gaul C et al, The Journal of Headache and Pain 2015',
  'Jayarwardena R et al, Hum Psychopharmacology-Clinical and Experimental 2017',
  'Mackus M et al, Current Drug Abuse Reviews 2017',
  'Pittler MH et al, BMJ 2005',
  'Kam-Hansen S et al, Science Translational Medicine 2015',
  'Chen L et al. American Journal of Public Health 2016',
  'Amer M et al, BMJ Open 2014',
  'Schweizerisches Gesundheitsobservatorium',
  'arznei-telegramm.de',
  'awl.ch',
  'peoplespharmacy.com',
  'hopkinsmedicine.org'
]
